<template>
  <AdminLayout>
    <section class="flex items-start px-14 space-x-9">
      <div class="w-full">
        <div class="mt-12">
          <div class="border rounded-lg py-7 px-8">
            <div class="flex justify-between mb-5">
              <p class="font-semibold text-xl text-neutral-800">Announcement</p>
              <button
                @click.prevent="openPopup"
                class="bg-blue-400 px-3 py-2 rounded-md text-white"
              >
                Add Announcement
              </button>
            </div>

            <div class="overflow-x-auto">
              <!-- Skeleton Loader -->
              <div v-if="loading">
                <div
                  v-for="n in 5"
                  :key="n"
                  class="grid grid-cols-10 bg-gray-200 animate-pulse divide-x-[1px] divide-white rounded-md shadow mt-1.5"
                >
                  <div class="px-2 py-3 col-span-1">
                    <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                  </div>
                  <div class="px-2 py-3 col-span-1">
                    <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                  </div>
                  <div class="px-2 py-3 col-span-7">
                    <div class="h-4 bg-gray-300 rounded w-full"></div>
                  </div>
                </div>
              </div>


              <div v-else class="min-w-[1220px]">
                <div
                  class="grid grid-cols-10 bg-[#ECF6FF] divide-x divide-[#eaeaea] rounded-md"
                >
                  <div
                    class="text-sm leading-none px-2 py-3 flex items-center font-normal"
                  >
                    Date
                  </div>
                  <div
                    class="text-sm leading-none px-2 py-3 flex items-center font-normal"
                  >
                    Publish Date
                  </div>
                  <div
                    class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-7"
                  >
                    Description
                  </div>
                  <div
                    class="text-sm leading-none px-2 py-3 flex items-center justify-center font-normal col-span-1"
                  >
                    Actions
                  </div>
                </div>
                <div
                  v-if="paginatedData.length === 0"
                  class="text-center py-6 text-neutral-500 text-sm"
                >
                  No data found.
                </div>
                <div>
                  <div
                    v-for="announcement in paginatedData"
                    :key="announcement.id.$oid"
                    class="grid grid-cols-10 bg-white divide-x divide-y divide-[#eaeaea]"
                  >
                    <div
                      class="text-sm leading-none px-2 py-3 flex items-center font-normal border-t border-[#eaeaea]"
                    >
                      {{ formatDate(announcement.created_at) }}
                    </div>
                    <div
                      class="text-sm leading-none px-2 py-3 flex items-center font-normal"
                    >
                      {{ formatDate(announcement.publish_date) }}

                    </div>
                    <div
                      class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-7"
                    >
                      {{ announcement.content }}
                    </div>
                    <!-- Delete Button -->
                    <div
                      class="text-sm leading-none px-2 py-3 flex items-center justify-center font-normal col-span-1"
                    >
                      <button
                        v-on:click="deleteAnnouncement(announcement.id)"
                        class="border rounded-3xl px-3 py-1.5 text-xs inline-block border-orange-200 bg-orange-50 text-orange-600"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Pagination -->
                <PaginationComponent
                  :totalItems="total"
                  :itemsPerPage="itemsPerPage"
                  v-model:currentPage="currentPage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <RightSideBar /> -->
    </section>

    <!-- Popup Modal -->
    <div
      v-if="isPopupOpen"
      class="fixed top-0 left-0 w-full h-full bg-black/60 flex items-center justify-center z-50"
    >
      <div class="bg-white w-full max-w-2xl p-5 rounded-lg">
        <div class="flex justify-between items-center border-b pb-2 mb-4">
          <h3 class="text-lg font-semibold text-blue-500">Add Announcement</h3>
          <button @click="closePopup" class="text-xl">&times;</button>
        </div>

        <form @submit.prevent="submitAnnouncement" class="space-y-4">
          <!-- <div>
                        <label class="block text-sm">Date</label>
                        <input type="date" v-model="form.date" required readonly class="w-full border px-3 py-2 rounded"/>

                    </div> -->
          <div>
            <label class="block text-sm">Publish Date</label>
            <input
              type="date"
              :min="today"
              v-model="form.publish_date"
              required
              class="w-full border px-3 py-2 rounded"
            />
          </div>
          <div>
            <label class="block text-sm">Description</label>
            <textarea
              v-model="form.content"
              rows="3"
              class="w-full border px-3 py-2 rounded"
            ></textarea>
          </div>
          <div class="text-center">
            <button
              type="submit"
              :disabled="submitting"
              class="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center gap-2 min-w-[100px]"
            >
              <span
                v-if="submitting"
                class="loader ease-linear rounded-full border-2 border-t-2 border-white h-4 w-4"
              ></span>
              <span>{{ submitting ? "Submitting..." : "Submit" }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </AdminLayout>
</template>

<script>
import axios from "axios";
import AdminLayout from "../AdminDashboard/AdminLayout.vue";
// import RightSideBar from '../../components/RightSideBar.vue';
import { BASE_URL } from "../../config";
import PaginationComponent from "../../components/PaginationComponent.vue";
import { createToast } from "mosha-vue-toastify";
import moment from "moment";

export default {
  name: "AnnouncementList",
  components: {
    AdminLayout,
    // RightSideBar,
    PaginationComponent,
  },
  data() {
    return {
      loading: true,
      isPopupOpen: false,
      form: {
        // date: '',
        publish_date: "",
        content: "",
        company_id: "",
      },
      today: new Date().toISOString().split("T")[0], // "YYYY-MM-DD"
      submitting: false,
      itemsPerPage: 10,
      currentPage: 1,
      total: 0, // Declare total items
      data: [],
      globalDateFormat: "",
    };
  },
  computed: {
    paginatedData() {
      //const start = (this.currentPage - 1) * this.itemsPerPage;
      //return this.data.slice(start, start + this.itemsPerPage);
      return this.data;
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
  },
  watch: {
    currentPage() {
      this.fetchAnnouncements(); // Fetch data when page changes
    },
  },
  mounted() {
    this.globalDateFormat = localStorage.getItem("globalDateFormat");
    this.fetchAnnouncements();
  },
  methods: {
    tostMessage(status, message) {
      createToast(
        {
          // title: title,
          description: message,
        },
        {
          type: status,
          timeout: 2500,
          position: "bottom-right",
          showIcon: "true",
        }
      );
    },
    //         formatDate(isoString) {
    //     return isoString.split("T")[0];
    //   },
    async deleteAnnouncement(id) {
      if (!confirm("Are you sure you want to delete this announcement?"))
        return;

      try {
        await axios.delete(`${BASE_URL}/announcements/${id}`);
        this.fetchAnnouncements(this.currentPage); // Refresh list after deletion
        this.tostMessage("success", "Announcement deleted successfully");
      } catch (error) {
        console.error("Failed to delete announcement:", error);
      }
    },

    openPopup() {
      //const today = new Date().toISOString().split('T')[0]; // format: YYYY-MM-DD
      //this.form.date = today;
      this.form.company_id = localStorage.getItem("company_id");
      this.isPopupOpen = true;
    },
    closePopup() {
      this.isPopupOpen = false;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        //date: '',
        publish_date: "",
        content: "",
        company_id: "",
      };
    },
    async fetchAnnouncements() {
      this.loading = true;
      try {
        const res = await axios.get(BASE_URL + `/announcements`, {
          params: {
            page: this.currentPage,
            limit: this.itemsPerPage,
            company_id: localStorage.getItem("company_id"),
          },
        });
        this.data = res.data.data; // Corrected
        this.total = res.data.total; // Corrected
      } catch (error) {
        console.error("Failed to fetch announcements:", error);
      } finally {
        this.loading = false;
      }
    },
    async submitAnnouncement() {
      this.submitting = true;
      try {
        await axios.post(BASE_URL + "/announcements", this.form);
        this.closePopup();
        this.fetchAnnouncements(); // Replace with actual company ID if needed
        this.tostMessage("success", "Announcement added successfully");
      } catch (error) {
        console.error("Failed to submit announcement:", error);
      } finally {
        this.submitting = false;
      }
    },

    formatDate(date) {
        if (!date) return '';
        return moment(date).format(this.globalDateFormat || "YYYY-MM-DD");
    },
  }
};
</script>
<style>
.loader {
  border-top-color: transparent;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
